import { ATTR_NAMES, getAttrFromProduct } from '../../../../types/attrNames';
import { CmsProduct } from '../../../../types/cmsProduct';

// Product-attribute texts that close the PL Offers section, after the offer
// boxes (CMS-2023, Genevieve 2026-10-01): EXCLUSIVE_OFFER_TEXT (HK) and
// CC_BUNDLE_TEXT (SG). Each shows only when the editor gave it a value.
const NOTE_ATTRS = [ATTR_NAMES.EXCLUSIVE_OFFER_TEXT, ATTR_NAMES.CC_BUNDLE_TEXT];

export const getOffersPlNotes = (product?: CmsProduct): string[] =>
  NOTE_ATTRS.map((name) =>
    getAttrFromProduct(name, product)?.value?.trim(),
  ).filter((value): value is string => !!value);
